<script setup>
import AppButton from '#/general/AppButton.vue'
import { useVModel } from '@vueuse/core'
import AppSwiper from '#/general/AppSwiper.vue'
import { inject } from 'vue'
const { isBrowser } = inject('Shared')
const props = defineProps({ visible: Boolean })
const emit = defineEmits(['update:visible'])
const visible = useVModel(props, 'visible', emit)

const benefits = [
  {
    title: 'Partnermodell 1',
    boxes: [
      'Wir Raumpioniere kümmern uns um die Klärung sämtlicher rechtlicher und finanzieller Fragen sowie um die komplette Projektentwicklung, Umsetzung und Vermarktung.',
      'Für Sie entstehen bis zur rechtskräftigen Baubewilligung keine Planungs- und Bewilligungskosten.',
      'Im Gegenzug für die risikofreie Entwicklung, die Sie von uns Raumpionieren erhalten, partizipieren wir gemeinsam am Mehrwert, den wir mit unserem Projekt erzielen.'
    ]
  },
  {
    title: 'Partnermodell 2',
    boxes: [
      'Wir Raumpioniere kümmern uns um die Klärung sämtlicher rechtlicher und finanzieller Fragen sowie um die komplette Projektentwicklung, Umsetzung und Vermarktung.',
      'Sie erhalten von uns sofort den vereinbarten Verkehrswert ausbezahlt, der auch das Potenzial Ihrer Liegenschaft miteinbezieht.',
      'Sichern Sie sich aus dem Verkaufserlös eine oder mehrere Wohneinheiten und gestalten Sie diese aktiv mit.'
    ]
  }
]

const breakpoints = {
  320: {
    slidesPerView: 1.2,
    spaceBetween: 20
  },
  1024: {
    slidesPerView: 2,
    spaceBetween: 40
  }
}
</script>

<template lang="pug">
.solutions--benefits
  .routerPageSize
    .solutions--benefits-title
      | Wovon Sie bei einer Zusammenarbeit mit uns
      br
      strong &#32; Raumpionieren &#32;
      | profitieren:
    app-swiper.solutions--benefit-boxes(:items="benefits" :breakpoints="breakpoints" v-if="isBrowser")
      template(#item="props")
        .solutions--benefit-box
          .solutions--benefit-box-title {{ props.item.title }}
          .solutions--benefit-box-row(v-for="box in props.item.boxes")
            .solutions--benefit-box-svg
              svg(viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg')
                path(d='M18.8152 1L1.02048 1.01564L1 26L22.7726 25.9844V16.7989' stroke='#5FEFC0' stroke-width='2' stroke-linejoin='round')
                path(d='M6.64258 11.4674L12.7561 18.4874L25.9998 3.28259' stroke='#5FEFC0' stroke-width='2' stroke-linejoin='round')
            .solutions--benefit-box-text(v-html="box")
    .solutions--benefits-btn-container
      app-button.solutions--benefits-btn(label="Jetzt Kontakt aufnehmen" padding="12px 28px" @click="visible = !visible")
</template>

<style lang="sass">
.swiper-slide
  height: auto !important
.solutions--benefits
  @media screen and (min-width: 1024px)
    margin-top: 87px
  @media screen and (max-width: 1024px)
    margin-top: 75px
    .routerPageSize
      padding-top: 0px !important
      padding-bottom: 0px !important
      padding-right: 0px !important
  .solutions--benefits-title
    font-weight: 500
    line-height: 130%
    text-align: center
    color: #22223C
    @media screen and (min-width: 1024px)
      font-size: 34px
      margin-bottom: 58px
    @media screen and (max-width: 1024px)
      font-size: 24px
      margin-bottom: 60px
  .solutions--benefit-boxes
    .solutions--benefit-box
      background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
      backdrop-filter: blur(5px)
      border-radius: 10px
      @media screen and (min-width: 1024px)
        padding: 30px
        min-height: 480px
      @media screen and (max-width: 1024px)
        padding: 25px 30px
        height: calc(100% - 50px)
      .solutions--benefit-box-title
        font-weight: 500
        line-height: 125%
        color: #5FEFC0
        margin-bottom: 20px
        @media screen and (min-width: 1024px)
          font-size: 34px
          margin-left: 52px
        @media screen and (max-width: 1024px)
          font-size: 24px
      .solutions--benefit-box-row
        @media screen and (min-width: 1024px)
          display: flex
        @media screen and (max-width: 1024px)
        &:not(:last-child)
          @media screen and (min-width: 1024px)
            margin-bottom: 30px
          @media screen and (max-width: 1024px)
            margin-bottom: 15px
        .solutions--benefit-box-svg
          @media screen and (min-width: 1024px)
            margin-right: 25px
            min-height: 25px
            min-width: 22px
            padding-top: 6px
          @media screen and (max-width: 1024px)
          svg
            @media screen and (min-width: 1024px)
              width: 27px
              height: 27px
            @media screen and (max-width: 1024px)
              width: 18px
              height: 18px
        .solutions--benefit-box-text
          font-weight: 400
          line-height: 150%
          color: #FFFFFF
          max-width: 480px
          @media screen and (min-width: 1024px)
            font-size: 20px
          @media screen and (max-width: 1024px)
            font-size: 16px
  .solutions--benefits-btn-container
    display: flex
    justify-content: center
    @media screen and (min-width: 1024px)
      margin-top: 43px
    @media screen and (max-width: 1024px)
      margin-top: 40px
      padding-right: 25px
    .solutions--benefits-btn
      @media screen and (min-width: 1024px)
        width: 330px
      @media screen and (max-width: 1024px)
        min-width: 320px
</style>
